import React from "react";

const Footer = () => {
    return (
        <footer className="page-color text-white text-center py-3 mt-auto">
            &copy; {new Date().getFullYear()} Lotusblüte – Gegründet von Oguzhan Cosgun & Kai Andre Grall
        </footer>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js